import Logo from '/assets/logo/logo_blue.svg';
import { useNavigate } from 'react-router-dom';
import { routePath } from '~/utils/constants';
import { header } from './AdminHeader.style';
import { AdminHeaderProfile } from './AdminHeaderProfile';

export const AdminHeader = () => {
  const navigate = useNavigate();

  return (
    <header.Container>
      <header.LeftCluster>
        <header.LogoContainer
          onClick={() => {
            navigate(routePath.resource);
          }}
        >
          <img src={Logo} alt="onebox3" style={{ height: '100%' }} />
        </header.LogoContainer>
        <header.NavButton
          variant="text"
          color="info"
          onClick={() => navigate(routePath.latestNews)}
        >
          最新消息
        </header.NavButton>
      </header.LeftCluster>
      <AdminHeaderProfile />
    </header.Container>
  );
};
